<template>
    <div>
        <h1>{{ $t('bestillingsbekr')}}</h1>
        <!-- Bestillings bekræftelse: http://10.0.2.39:8080/da/1000/faktura/1649057261.8518/complete/b -->
        <!-- Hent faktura: https://api.kunder.bbsystems.dk/api/v2/koncern/1000/booking/1649057261.8518/pdf -->
        <!-- <p>Refno: {{ this.$route.params.refno }}</p> -->
        <!-- <p>Complete: {{ this.$route.params.complete }}</p> -->
        <!-- <p>Locale: {{ this.locale }} </p> -->
        <!-- <p>Backendurl {{ this.backendurl }}</p> -->
        <!-- <p>Hotel: {{this.$store.getters.bookingSummary['hotel']}}</p> -->
        <!-- <p>detailedExtras: {{ this.$store.getters.bookingSummary.booking.detailedExtras }}</p> -->

        <!-- Vis 'loading' ikon mens API data loader... -->
        <div class="loading" v-if="apiLoaded === 0">
            <img src="@/assets/loading.svg" alt="Kontrollerer betaling">
            <p>{{ $t('kontrolbetaling') }}</p>
        </div>

<!-- 
        <div>
            <p>Total Pris: {{this.$store.getters.bookingSummary.booking.summary.inclVAT}}</p>
            <p>Booking data:</p>
            {{this.$store.getters.bookingInProgress}}<br />
            <p>Kunde data: </p>
            {{this.$store.getters.customerData}} <br />
            <p>{{this.$store.getters.paymentPriceData}}</p>

            <pre>
                Booking Summary:
                {{this.$store.getters.bookingSummary}}
            </pre>
        </div>
 -->

    <span v-if="apiLoaded === 1">
        <table width="80%" border="0" cellpadding="10" cellspacing="10" bgcolor="#FFFFFF" align="center" style="max-width: 850px;">
            <tr>
                <td align="right" valign="top">
                    <!-- Hvis kundens logo ikke findes, så vis et default logo -->
                    <img v-bind:src="this.backendurl+'/storage/'+this.$store.getters.bookingSummary['hotel']+'.png'" alt="Logo" @error="defaultLogo">
                </td>
            </tr>

            <tr>
                <td align="center" valign="top">
                    <h2 style="font-weight: 100; margin-bottom: 5px;">{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['tak']) }}</h2>
                    <b>{{ this.$store.getters.bookingSummary['hotelname'] }} </b>{{ this.$store.getters.bookingSummary['texts']['address'] }}<br>

                    <!-- <p>{{ this.$store.getters.bookingSummary['texts']['invoiceAttached'] }}</p> -->
                    <p>Du kan hente din faktura <a v-bind:href="axios.defaults.baseURL+'/koncern/'+this.$route.params.koncern+'/booking/'+ this.$route.params.refno +'/pdf'">her</a></p>
                    <br>
                    <br>

                    <table width="100%" bgcolor="#dff0f5" border="0">
                        <tr>
                            <td align="center">
                                <table border="0" cellpadding="5" cellspacing="5" bgcolor="#dff0f5" style="margin-left: 0px; margin-right: 0px; width: 85%; max-width: 300px;">
                                    <tr>
                                        <td align="right" valign="top" style="padding-left: 0px;">
                                            <img alt="Check in" v-bind:src="this.backendurl+'/storage/tjek-ind.png'">
                                        </td>
                                        <td align="left" valign="middle">
                                            <p style="font-size: 80%; margin-top: 0px; margin-bottom: 0px; margin-left: 0px; margin-right: 0px;">{{ this.$store.getters.bookingSummary['texts']['arrivalFrom'] }}</p>
                                            <p style="font-weight: 100; font-size: 140%; margin-top: 5px; margin-bottom: 0px; margin-left: 0px; margin-right: 0px;">{{ this.$store.getters.bookingSummary['texts']['checkin'] }}</p>
                                        </td>
                                        <td align="right" valign="top">
                                            <img alt="Check out" v-bind:src="this.backendurl+'/storage/tjek-ud.png'">
                                        </td>
                                        <td align="left" valign="middle">
                                            <p style="font-size: 80%; margin-top: 0px; margin-bottom: 0px; margin-left: 0px; margin-right: 0px;">{{this.$store.getters.bookingSummary['texts']['departureNLT'] }}</p>
                                            <p style="font-weight: 100; font-size: 140%; margin-top: 5px; margin-bottom: 0px; margin-left: 0px; margin-right: 0px;">{{ this.$store.getters.bookingSummary['texts']['checkout'] }}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right" valign="top">
                                            <img alt="Door code" v-bind:src="this.backendurl+'/storage/key_black.png'">
                                        </td>
                                        <td colspan="3" align="left" valign="middle">
                                            <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['doorcode']) }} *{{ this.$store.getters.bookingSummary['doorcode'] }} #</b><br>
                                            <i>{{ this.$store.getters.bookingSummary['texts']['rememberThis'] }}</i>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <br>
                    <br>
                    <br>

                    <table border="0" cellspacing="0" width="100%">
                        <tr>
                            <td width="800" align="center">
                                <table width="100%" style="border-collapse: collapse; max-width: 800px;">

                                    
                                    <!-- {{-- Værelser --}} -->
                                        <tr style="border-bottom: 1px solid black;" v-if="this.$store.getters.bookingSummary.booking.rooms && this.$store.getters.bookingSummary.booking.rooms.length > 0">
                                            <td>

                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['room']) }}</b>
                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['arrival']) }}</b>
                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['departure']) }}</b>
                                            </td>
                                        </tr>

                                        <!-- <tr style="border-bottom: 1px solid black;" v-for="bookingLine in this.bookingSummary.booking.rooms" v-bind:key="bookingLine.room"> -->
                                        <tr style="border-bottom: 1px solid black;" v-for="bookingLine in computedBookingSummary.booking.rooms" v-bind:key="bookingLine.room">
                                            <td>
                                                <img v-bind:src="backendurl+'/storage/ikon-'+ bookingLine.roomType +'.png'" alt="1" height="60" width="60" style="padding-top: 5px;">
                                            </td>
                                            <td>
                                                {{ ucfirst(bookingSummary['texts']['room']) }} {{ bookingSummary['texts']['nr'] }} {{ bookingLine.room }}
                                            </td>
                                            <td>
                                                {{ bookingSummary['booking']['arrival'] }}
                                            </td>
                                            <td>
                                                {{ bookingSummary['booking']['departure'] }}
                                            </td>
                                        </tr>

                                    <!-- {{-- Langtidsparkering --}} -->
                                        <tr style="border-bottom: 1px solid black;" v-if="this.$store.getters.bookingSummary.booking.parkings && this.$store.getters.bookingSummary.booking.parkings.length > 0">
                                            <td>
                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['parking']) }}</b>
                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['arrival']) }}</b>
                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['departure']) }}</b>
                                            </td>
                                        </tr>

                                        <tr style="border-bottom: 1px solid black;" v-for="bookingLine in this.$store.getters.bookingSummary.booking.parkings" v-bind:key="bookingLine.parking">
                                            <td>
                                                <img alt="1" v-bind:src="backendurl+'/storage/ikon-P.png'" height="60" width="60" style="padding-top: 5px;">
                                            </td>
                                            <td>
                                                {{ ucfirst(bookingSummary['texts']['nr']) }} {{ bookingLine.space_no }}
                                            </td>
                                            <td>
                                                {{ bookingSummary['booking']['arrival'] }}
                                            </td>
                                            <td>
                                                {{ bookingSummary['booking']['departure'] }}
                                            </td>
                                        </tr>

                                    <!-- {{-- Mødelokale --}} -->
                                    <tr style="border-bottom: 1px solid black;" v-if="this.$store.getters.bookingSummary.booking.conference && this.$store.getters.bookingSummary.booking.conference.length > 0">
                                        <td>
                                        </td>
                                        <td>
                                            <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['conferenceRoom']) }}</b>
                                        </td>
                                        <td>
                                            <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['arrival']) }}</b>
                                        </td>
                                        <td>
                                            <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['departure']) }}</b>
                                        </td>
                                    </tr>

                                    <tr style="border-bottom: 1px solid black;" v-for="bookingLine in this.$store.getters.bookingSummary.booking.conference" v-bind:key="bookingLine.conference">
                                        <td>
                                            <img alt="1" v-bind:src="backendurl+'/storage/ikon-C.png'" height="60" width="60" style="padding-top: 5px;">
                                        </td>
                                        <td>
                                            {{ ucfirst(bookingSummary['texts']['nr']) }} {{ bookingLine.room_no }}
                                        </td>
                                        <td>
                                            {{ bookingSummary['booking']['arrival'] }}
                                        </td>
                                        <td>
                                            {{ bookingSummary['booking']['departure'] }}
                                        </td>
                                    </tr>


                                    <!-- {{-- Selskabslokale --}} -->
                                        <tr style="border-bottom: 1px solid black;" v-if="this.$store.getters.bookingSummary.booking.selskabslokale && this.$store.getters.bookingSummary.booking.selskabslokale.length > 0">
                                            <td>

                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['room']) }}</b>
                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['arrival']) }}</b>
                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['departure']) }}</b>
                                            </td>
                                        </tr>

                                        <!-- <tr style="border-bottom: 1px solid black;" v-for="bookingLine in this.bookingSummary.booking.rooms" v-bind:key="bookingLine.room"> -->
                                        <tr style="border-bottom: 1px solid black;" v-for="bookingLine in this.$store.getters.bookingSummary.booking.selskabslokale" v-bind:key="bookingLine.room">
                                            <td>
                                                <img v-bind:src="backendurl+'/storage/ikon-'+ bookingLine.roomType +'.png'" alt="1" height="60" width="60" style="padding-top: 5px;">
                                            </td>
                                            <td v-if="bookingLine.roomType === 'S'">
                                                Selskabslokale
                                            </td>
                                            <td v-else>
                                                {{ ucfirst(bookingSummary['texts']['room']) }} {{ bookingSummary['texts']['nr'] }} {{ bookingLine.room }}
                                            </td>
                                            <td>
                                                {{ bookingSummary['booking']['arrival'] }}
                                            </td>
                                            <td>
                                                {{ bookingSummary['booking']['departure'] }}
                                            </td>
                                        </tr>
                                    </table>



                                    <!-- {{-- Ekstra tilkøb header --}} -->
                                    <table width="100%" style="border-collapse: collapse; max-width: 800px;">
                                        <tr valign="bottom" style="border-bottom: 1px solid black; height: 50px;" v-if="(this.$store.getters.bookingSummary.booking.extras && this.$store.getters.bookingSummary.booking.extras.length > 0) || (this.$store.getters.bookingSummary.booking.detailedExtras && Object.keys(this.$store.getters.bookingSummary.booking.detailedExtras).length > 0)">
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['extras']) }}</b>
                                            </td>
                                            <td>
                                                <b>Værelse</b>
                                            </td>
                                            <td>
                                                <b>Antal</b>
                                            </td>

                                            <!-- <td align="right">
                                                <b>Periode</b>
                                            </td> -->

<!--                                             <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['arrival']) }}</b>
                                            </td>
                                            <td>
                                                <b>{{ this.ucfirst(this.$store.getters.bookingSummary['texts']['departure']) }}</b>
                                            </td> -->
                                        </tr>

                                        <!-- "Gamle" ekstra tilkøb -->
                                        <tr style="border-bottom: 1px solid black; height: 50px;"  v-for="bookingExtras in this.$store.getters.bookingSummary.booking.extras" v-bind:key="bookingExtras.name">
                                            <td>
                                                {{ bookingExtras.name }}
                                            </td>
                                            <td>
                                                -
                                            </td>
                                            <td>
                                                {{ bookingExtras.qty }}
                                            </td>

                                            <!-- <td align="right">
                                                {{ bookingSummary['booking']['arrival'] }} - {{ bookingSummary['booking']['departure'] }}
                                            </td> -->

                                        </tr>
                                    
                                        <!-- {{-- Detaljeret Ekstra tilkøb --}} -->
                                        <template v-for="(extraIdMain, keyExtraId) in this.$store.getters.bookingSummary.booking.detailedExtras">
                                            <template v-for="(extraId, keyRoomNo, indexExtraId) in extraIdMain">
                                            <tr style="border-bottom: 1px solid black; height: 50px;"  v-for="(bookingDetailedExtras, keyDetailedExtras, indexDetailedExtras) in extraId" v-bind:key="`key_${indexExtraId}_${indexDetailedExtras}`">
                                                <td>
                                                    {{ ucfirst(bookingDetailedExtras.headline) }}
                                                </td>
                                                <td>
                                                    {{ keyRoomNo }}
                                                </td>
                                                <td>
                                                    {{ bookingDetailedExtras.antal_personer*bookingDetailedExtras.dates.length }}
                                                </td>

                                                <!-- <td style="font-size: 75%;" align="right">
                                                    <span v-for="(date, dateKey, dateIndex) in bookingDetailedExtras.dates" v-bind:key="dateIndex">
                                                    {{ date }}<br />
                                                    </span>
                                                </td> -->

                                            </tr>
                                            </template>
                                        </template>
                                </table>

                                <br /><b>{{ this.$store.getters.bookingSummary['texts']['bekr'] }}</b>
                            </td>
                        </tr>
                    </table>
                    
                </td>
            </tr>
        </table>
    </span>
    <!-- <p> {{ this.frontendurl+'/'+locale+'/'+this.$route.params.koncern }} </p> -->   
    <p v-if="this.$route.params.complete === 'complete' && apiLoaded === 1">Tryk <a v-bind:href="this.frontendurl+'/'+locale+'/'+this.$route.params.koncern">her</a> for at lave en ny booking</p>

    </div>
</template>

<script>
import i18n from '@/plugins/i18n';
import axios from 'axios'

//import swal from 'sweetalert2'
/* 
    swal.fire({
       icon: 'error',
       title: 'Generisk Fejl!',
       text: 'Fejlmeddelelse...',
       showCloseButton: true,
       showConfirmButton: false,
     })
 */

export default {
    data() {
        return {
            bookingSummary: {},
            locale: i18n.locale,
            apiLoaded: 0,
            axios,
        };
    },

    mounted() {
        // Hvis bookingen er lavet (== page reload) så hent bookingInfo fra den booking der er lavet.
        if(this.$route.params.complete === 'complete') {
            //console.log('Bookingen er lavet - vis data fra den booking der er angivet i route');
            this.$store.dispatch("getBookingSummary", {'refNo': this.$route.params.refno, 'koncern': this.$route.params.koncern}).then(() => { this.apiLoaded = 1; this.bookingSummary = this.$store.getters.bookingSummary});
            // Slet bookingInProgress og customerData fra localStorage så de ikke forstyrrer hvis der laves en ny booking
            //this.$store.dispatch("addCustomerData", {});
            localStorage.removeItem("bookingInProgress");
            localStorage.removeItem("customerData");
            localStorage.removeItem("invoice");
            sessionStorage.removeItem("bookingInProgress");
            sessionStorage.removeItem("customerData");
            sessionStorage.removeItem("invoice");
        } else {
            // TODO check også om det er creditcard eller bank/EAN betaling
            if(this.$route.params.paymentType === 'c' && this.$route.params.complete === 'initial') {
                // En booking lavet med betalingskort
                //console.log('Bookingen er ikke lavet, så det gør vi nu.');

                // Start med at decode URLParams
                var decodedURLParams = atob(this.$route.params.URLparams);
                var URLParams = JSON.parse(decodedURLParams);

                // Her laver vi et API-kald til QuickPay og kontrollerer status på betalingen. 
                // Hvis betalingen er OK gennemføres bookingen.
                // Hvis betalingen ikke er OK redirectes til fejl-side.
                this.$store.dispatch("qpPayCheck", {'koncern': this.$route.params.koncern, 'postnr': URLParams.bookingInProgress.hotel, 'refNo': this.$route.params.refno}).then(
                    () => {
                        if(this.$store.getters.qpPayCheck.state === 'processed' || this.$store.getters.qpPayCheck.state === 'new') {
                            if(this.$store.getters.qpPayCheck.test_mode === true) {
                                // For at acceptere booking med test kort:
                                this.mkBooking('c', URLParams.customerData, URLParams.bookingInProgress);
                                this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/faktura/'+this.$route.params.refno+'/complete/c' })

                                // For at afvise betaling med test kort:
                                //this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/cancel/' })
                                //console.log('payment ok... test mode...');
                            } else {
                                this.mkBooking('c', URLParams.customerData, URLParams.bookingInProgress);
                                this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/faktura/'+this.$route.params.refno+'/complete/c' })
                                //console.log('payment ok...');
                            }
                        } else {
                            this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/cancel/' })
                            //console.log('payment not ok...');
                        }
                    } );
            } else if (this.$route.params.paymentType === 'b' && this.$route.params.complete === 'initial') {
                // En booking lavet med Bankoverførsel
                // Så der er ingen kontrol af betalingen - vi opretter derfor bookingen med det samme.
                this.mkBooking('b');
                this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/faktura/'+this.$route.params.refno+'/complete/b' })
            } else if (this.$route.params.paymentType === 'e' && this.$route.params.complete === 'initial') {
                // En booking lavet med EAN faktura
                // Så der er ingen kontrol af betalingen - vi opretter derfor bookingen med det samme.
                this.mkBooking('e');
                this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/faktura/'+this.$route.params.refno+'/complete/e' })
            } else {
               console.log('booking er ikke initial og ikke complete!:');
               console.log(this.$route.params.complete)
               console.log('refno:');
               console.log(this.$route.params.refno);
            }
        }
    },
    computed: {
        /* Hvis der bliver bestilt på Best Western må der ikke blive vist værelsesnr.
         * Derfor gennemgår vi alle værelsesnr og erstatter med '-' hvis der er 
         * booket på Best Western hotellet.
         */
        computedBookingSummary: function() {
            var bookingSummary = this.$store.getters.bookingSummary;
            if (bookingSummary.hotelname === 'BB-Hotel Kastrup Best Western') {    // Kun for dette hotel

                // Sæt 'room' til '-' for alle værelser
                for(var r=0; r < bookingSummary.booking.rooms.length; r++) {
                    bookingSummary.booking.rooms[r].room = '-';
                }
            }

            return bookingSummary;
        }
    },
    methods: {
        // 1. opret booking
        // 2. når 1. er færdig, så hent booking info som JSON
        // 3. når 2. er færdig, så sæt apiLoaded til 1
        mkBooking(paymentType, customerData = this.$store.getters.customerData, bookingInProgress = this.$store.getters.bookingInProgress) {

            /**
             *  På fakturasiden skal der ventes på callback fra QuickPay, og kontrolleres
             *  at betalingen er gået korrekt igennem før fakturaen dannes.
             *  Dette gøres ved et API-kald før fakturaen dannes.
             */

            // TODO: hvis paymentType == e skal "ean" JSON-objektet sendes med API kaldet

            console.log('Laver ny booking med refno:');
            console.log(this.$route.params.refno);

            // Sæt landekoden før telefonnummeret inden vi laver API kald til /booking
            customerData.phone = customerData.countryCode + " " + customerData.phone;
            
            this.$store.dispatch("getInvoice", {
                "koncern": this.$route.params.koncern,
                "refno": this.$route.params.refno,
                "paymentType": paymentType,
                "language": this.locale,
                "customer": customerData,
                "booking": bookingInProgress,
                "ean": this.$store.getters.eanData
            }).then(() => {
                this.$store.dispatch("getBookingSummary", {'refNo': this.$route.params.refno, 'koncern': this.$route.params.koncern}).then(() => { 
                    this.apiLoaded = 1; 
                    this.bookingSummary = this.$store.getters.bookingSummary;
                    window.dataLayer.push({'event':'orderSuccess','orderTotal':  this.$store.getters.bookingSummary.booking.summary.inclVAT });   // Google Ads konverterings sporing
                });
                //this.$store.dispatch("getBookingSummary", this.refNo.refNo).then(() => { this.$router.push({ path: 'faktura/'+this.refNo.refNo }) });
            });            
        },
        ucfirst(string) {
            return string[0].toUpperCase() + string.substring(1);
        },
        checkPayment(qpPayCheck) {
            if(qpPayCheck.state === 'processed' || qpPayCheck.state === 'new') {
                if(qpPayCheck.test_mode === true) {
                    console.log('payment ok... test mode...');
                } else {
                    console.log('payment ok...');
                }
            } else {
                console.log('payment not ok...');
            }
        },
        // Returnér et default logo
        defaultLogo(event) {
            event.target.src = this.backendurl+'/storage/LOGO_100.png'
        },
    }
}
</script>

<style scoped>
table {
    color: black;
    text-transform: none;
}

.loading {
    background-color: #ffffff;
    color: #000000;
}

</style>